export default __webpack_public_path__ + "c295e7f71970f03c0549228b1c18120a.woff2";